module.exports = __webpack_public_path__ + "img/UTROCK.65c445f3.png";